import { OverlayView } from "@react-google-maps/api";
import DSBox from "../../system-design/DSBox";
import LoopPreview from "./LoopPreview";
import { MapDevice } from "../../../api/admin";

type DeviceMarkerProps = {
  device: MapDevice;
};

const DeviceMarker = ({ device }: DeviceMarkerProps) => {
  if (!device.randomLocation || !device.loopUrl) return null;

  return (
    <OverlayView
      position={{
        lat: device.randomLocation.latitude,
        lng: device.randomLocation.longitude,
      }}
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
    >
      <DSBox
        sx={{
          right: "11px",
          borderRadius: "50%",
          width: 24,
          height: 24,
          position: "relative",
          overflow: "hidden",
          borderStyle: "dotted",
          borderWidth: "1px",
          borderColor: "black",
        }}
      >
        <DSBox
          sx={{
            display: "flex",
            justifyContent: "center",
            position: "absolute",
            top: "0%",
            left: "0%",
            width: "100%",
            aspectRatio: "1/1",
          }}
        >
          <LoopPreview loopUrl={device.loopUrl} alt="device" size={48} />
        </DSBox>
      </DSBox>
    </OverlayView>
  );
};

export default DeviceMarker;
